module.exports = __webpack_public_path__ + "img/mind_background_1_th.927b8f3f.png";